import list from './list';
import edit from './edit';
import add from './add';

const module = {
  namespaced: true,
  modules: {
    list,
    edit,
    add,
  },
};

export default module;
